export const RECEIVE_PAYLOAD = 'ReceivePayload';
export const DELETE_PAYLOAD = 'DeletePayload';


// WEBPACK FOOTER //
// src/helpers/signalR.js